<template>
  <PrivacyPolicyEmbedding
    :embed-type="mgnlProps.embedType"
    :service-toggle="mgnlProps.serviceToggle"
  />
</template>

<script lang="ts" setup>
import PrivacyPolicyEmbedding from '~/components/Shared/PrivacyPolicyEmbedding/PrivacyPolicyEmbedding.vue';
import { PrivacyPolicyEmbeddingBuilder, WrapperProps } from '~/components/Shared/PrivacyPolicyEmbedding/PrivacyPolicyEmbedding.model';

const props = defineProps(WrapperProps);
const mgnlProps = PrivacyPolicyEmbeddingBuilder.build(props);
</script>
